import noopFn from 'lodash/fp/noop';

export const noop = noopFn;
